import { __extends } from "tslib";
import { SkeletonBinaryLERPNode } from '../nodes/SkeletonBinaryLERPNode';
import { CrossfadeTransitionState } from './CrossfadeTransitionState';
/**
 * A skeleton animation node that uses two animation node inputs to blend a lineraly interpolated output of a skeleton pose.
 */
var CrossfadeTransitionNode = /** @class */ (function (_super) {
    __extends(CrossfadeTransitionNode, _super);
    /**
     * Creates a new <code>CrossfadeTransitionNode</code> object.
     */
    function CrossfadeTransitionNode() {
        var _this = _super.call(this) || this;
        _this._pStateClass = CrossfadeTransitionState;
        return _this;
    }
    return CrossfadeTransitionNode;
}(SkeletonBinaryLERPNode));
export { CrossfadeTransitionNode };
